import React from 'react'
import "./contactPage.css"
// components
import ContactForm from '../../components/contact/ContactForm'

const Contact = () => {
  return (
    <div>
      <ContactForm />
    </div>
  )
}

export default Contact
